import {
  TableColumn,
  TableColumnInputType,
  TableColumns,
} from "src/requests/table/types";
import { DataTemplateItem } from "src/requests/templateBuilder/types";
import { ColumnInfo, TableInfo } from "../../types";
import { Option } from "../../../../atoms/inputs/FlowioSelect/types";
import { createOption } from "../../../../../utils/options";

export const dataTemplateItem2tableInfo = (
  item?: DataTemplateItem
): TableInfo | undefined => {
  if (!item) return undefined;

  const { displayColumn, globalId, tableId, tableName, isBase } = item;

  const tableDisplayName = `${tableName}${isBase ? "" : ` (${globalId})`}`;

  return {
    id: String(globalId),
    displayName: tableDisplayName,
    displayColumnId: displayColumn,
    tableId,
  };
};

export const column2columnInfo = (
  col: TableColumn,
  tableId?: string | undefined
): ColumnInfo => ({
  id: col.columnAlias,
  options: col.selectItems,
  isSelect: col.isSelect,
  isMultiSelect: col.inputType === TableColumnInputType.Category,
  isOverviewSelect: col.inputType === TableColumnInputType.OverviewSelect,
  overviewSelectTemplateId: col.overviewSelectTemplateId,
  unformattedInputType: col.unformattedInputType,
  displayName: col.displayName,
  typeText: col.typeText,
  table: tableId,
  presentationInputType: col.inputType,
});

export const createColumnInfoFromColumns = (
  columns: TableColumns,
  columnIdentifier: string
): ColumnInfo => column2columnInfo(columns[columnIdentifier]);

export const column2standardOption = (column: TableColumn): Option =>
  createOption(column.columnAlias, column.displayName);

// For cases where ColumnDescriptor defines both table and column
export const column2globallyUniqueOption = (column: TableColumn) => {
  const uniqueLabel = `${column.displayName} (${column.tableName})`;
  return createOption(column.withTemplateUniqueName, uniqueLabel);
};
